"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentryError = void 0;
/**
 * This Error extension can be enriched with additional information which are copied to the sentry context
 *
 * !! BE CAREFULL with the size of that additional infos !!
 * https://docs.sentry.io/platforms/javascript/enriching-events/context/#size-limitations
 *
 */
class SentryError extends Error {
    constructor(message, additionalInformation) {
        super(message);
        this.additionalInformation = additionalInformation;
    }
}
exports.SentryError = SentryError;
//# sourceMappingURL=sentry-error.js.map